import {Observable} from 'rxjs';
import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from './../../../environments/environment';
import {WikiGroupOrder, WikiItemOrder} from './../../wiki/models/wiki.model';
import {WikiGroup, WikiItem} from '../../wiki/models/wiki.model';

@Injectable({
  providedIn: 'root',
})
export class WikiApiService {
  private http = inject(HttpClient);

  private get url() {
    return `${environment.apiUrl}/wiki`;
  }

  getAll(): Observable<WikiGroup[]> {
    return this.http.get<WikiGroup[]>(`${this.url}/groups`);
  }

  createWikiGroup(group: WikiGroup): Observable<WikiGroup> {
    return this.http.post<WikiGroup>(`${this.url}/groups`, group);
  }

  updateWikiGroup(group: WikiGroup): Observable<WikiGroup> {
    return this.http.put<WikiGroup>(`${this.url}/groups/${group._id}`, group);
  }

  deleteWikiGroup(id: string): Observable<{success: boolean; id: string}> {
    return this.http.delete<{success: boolean; id: string}>(`${this.url}/groups/${id}`);
  }

  updateWikiGroupOrder(wikiGroupOrder: WikiGroupOrder): Observable<{message: string}> {
    return this.http.put<{message: string}>(`${this.url}/groups-reorder`, wikiGroupOrder);
  }

  getWikiItem(id: string): Observable<WikiItem> {
    return this.http.get<WikiItem>(`${this.url}/groups/items/${id}`);
  }

  createWikiItem(item: WikiItem): Observable<WikiItem> {
    const groupId = item.groupId;
    return this.http.post<WikiItem>(`${this.url}/groups/${groupId}/items`, item);
  }

  updateWikiItem(item: WikiItem): Observable<WikiItem> {
    const groupId = item.groupId;
    return this.http.put<WikiItem>(`${this.url}/groups/${groupId}/items/${item._id}`, item);
  }

  deleteWikiItem(item: WikiItem): Observable<{success: boolean; id: string}> {
    const groupId = item.groupId;
    return this.http.delete<{success: boolean; id: string}>(`${this.url}/groups/${groupId}/items/${item._id}`);
  }

  updateWikiItemOrder(wikiItemOrder: WikiItemOrder): Observable<{message: string}> {
    const groupId = wikiItemOrder.groupId;
    const itemOrder = {itemId: wikiItemOrder.itemId, newOrder: wikiItemOrder.newOrder};
    return this.http.put<{message: string}>(`${this.url}/group-items-reorder/${groupId}`, itemOrder);
  }
}
